/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class SearchControl extends React.Component {
	constructor(props) {
		super(props);

		let value = '';
		if (props.fieldValue !== '') {
			value = props.defaultValue;
		}

		this.state = {
			value,
			timeoutID: 0,
			debounceId: 0,
			showReset: false,
			fieldHidden: false
		};

		this.onSearchChange = this.onSearchChange.bind(this);
		this.onSearchClick = this.onSearchClick.bind(this);
		this.onKeyUp = this.onKeyUp.bind(this);
		this.onResetSearch = this.onResetSearch.bind(this);
		this.onFocus = this.onFocus.bind(this);
		this.touchFocus = this.touchFocus.bind(this);
		this.setFieldAndSearch = this.setFieldAndSearch.bind(this);

		this.mainInput = React.createRef();

	}

	componentDidMount() {

		if (this.props.defaultFocus) {
			this.mainInput.current.focus();
		}

		if (this.props.expandable) {
			this.setState({
				fieldHidden: true
			});
		}

	}

	componentDidUpdate(prevProps, prevState, snapshot) {

		if (this.props.fieldValue !== '' && prevState.value !== this.props.fieldValue) {
			this.setFieldAndSearch(this.props.fieldValue);
		}

		if ((prevProps.reset === undefined || !prevProps.reset) && this.props.reset) {
			this.onResetSearch();
		}

		if (prevProps.defaultFocus === false && this.props.defaultFocus === true) {
			if (document.activeElement !== this.mainInput.current) {
				this.mainInput.current.focus();
			}
		}

	}

	onSearchChange(e) {

		let state = this.state,
			newValue = e.currentTarget.value,
			control = this;

		e.persist();

		if (state.timeoutID) {
			window.clearTimeout(state.timeoutID);
		}
		state.timeoutID = window.setTimeout(function(){
			// call the registered callback to do whatever it needs to
			control.props.changeHandler.apply(this, [e, state.value]);
		}, 1200);

		state.value = newValue;
		state.showReset = true;
		// state.selectionStart = this.findSelectionStart(e, state.value);
		// state.selectionEnd = this.findSelectionEnd(e, state.value);
		this.setState(state);

	}

	onSearchClick(e) {
		var state = this.state;

		if (state.timeoutID) {
			 window.clearTimeout(state.timeoutID);
			 state.timeoutId = 0;
		}
		e.persist();
		this.props.changeHandler.apply(this, [e, state.value]);

		this.setState(state);
	}

	/*
	 * Begin the search immediately if the user hits enter
	 */
	onKeyUp(e) {

	    let state = this.state,
	      	newValue = e.target.value;

	    if(e.key == 'Enter') {
			window.clearTimeout(state.timeoutID);
			state.timeoutID = 0;

			window.clearTimeout(state.debounceId);
			e.persist();
			state.debounceId = setTimeout(() => {
				this.props.changeHandler.apply(this, [e, newValue]);
				state.debounceId = 0;
			}, 500);

			this.setState(state);

	    }

	}

	onResetSearch(e) {
		if (e) {
			this.props.changeHandler.apply(this, [e, '']);
		}

		this.props.deleteApiError(['FEED_VALIDATE', 'FEED_SEARCH']);

		if (this.mainInput.current) {
			this.mainInput.current.value = '';
			this.mainInput.current.focus();
		}

		this.setState({
			value: '',
			showReset: false
		});
	}

	onFocus(e) {

		// only relevant in advanced feed situations
		if (this.props.runOnFocus === true) {
			if (e.target.value !== '') {
				this.props.changeHandler.apply(this, [e, this.state.value]);
			}
		}

		if (typeof this.props.focusHandler === 'function') {
			this.props.focusHandler.apply(this, [e]);
		}

	}

	touchFocus(e) {
		this.mainInput.current.focus();
	}

	setFieldAndSearch(value) {
		this.props.changeHandler.apply(this, [null, value]);
		this.mainInput.current.value = value;
		this.setState({
			value: value,
			showReset: true
		});
	}

	render() {
		var searchClass = "search-control",
			wrapperClass = "search-wrapper",
			buttonElement = "",
			resetSearch = null,
			searchValue = this.state.value,
			fieldIcon = null,
			onBlur = null;

		if (this.props.extraClasses) {
			searchClass += " " + this.props.extraClasses;
		}

		if (this.props.wrapperClass) {
			wrapperClass += " " + this.props.wrapperClass;
		}

		if (this.props.buttonClass) {
			buttonElement = <div className={this.props.buttonClass} onClick={this.onSearchClick} role="button" aria-label="search">{this.props.buttonLabel}</div>;
		}

		if (this.props.fieldIcon) {
			fieldIcon = (
				<i className={this.props.fieldIcon}></i>
			);
			searchClass += " " + "field-icon";
		}

		if (this.state.value !== '') {
			resetSearch = (
				<div className='reset-search' onClick={this.onResetSearch} role="button" aria-label="reset search"><i className="fa fa-times-circle"></i></div>
			);
		}

		if (this.props.expandable) {
			onBlur = (e) => {
				if (e.target.value === '') {
					this.setState({
						fieldHidden: true
					});
				}
			}
		}

		if (this.state.fieldHidden) {
			return (
				<div className={`${wrapperClass} collapsed`} role="button" aria-label="open search" onClick={(e) => {
					this.setState({
						fieldHidden: false
					});
				}}>
					<i className="icon ion-android-search"/>
				</div>
			)
		}

		return (
			<div className={wrapperClass}>
				{resetSearch}
				{fieldIcon}
				<input
					type="text"
					className={searchClass}
					ref={this.mainInput}
					placeholder={this.props.placeholder}
					onChange={this.onSearchChange}
					onKeyUp={this.onKeyUp}
					onFocus={this.onFocus}
					onBlur={onBlur}
					onTouchStart={this.touchFocus}
					value={searchValue}
					data-hj-whitelist/>
				{buttonElement}
			</div>
		);
	}
};

SearchControl.propTypes = {
	changeHandler: PropTypes.func,
	extraClasses: PropTypes.string,
	placeholder: PropTypes.string,
	wrapperClass: PropTypes.string,
	reset: PropTypes.bool,
	focusHandler: PropTypes.func,
	defaultFocus: PropTypes.bool,
	context: PropTypes.string,
	defaultValue: PropTypes.string
};

SearchControl.defaultProps = {
	changeHandler: () => {},
	extraClasses: '',
	buttonClass: false,
	buttonLabel: <i className="fa fa-search" aria-hidden="true"></i>,
	placeholder: '',
	wrapperClass: '',
	reset: false,
	focusHandler: () => {},
	defaultFocus: true,
	fieldValue: '',
	context: '',
	runOnFocus: true
};

export default SearchControl;
